import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Watch } from "react-loader-spinner";
import LSHeader from "../../containers/LSHeader";
import { ApiService } from '../../containers/Services/apiservice';
let apiServices = new ApiService();
function ResetPasswordLink() {
    const [errorMessage, setErrorMessage] = useState("")
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [registerData, setRegisterData] = useState({ cnfpassword: '', password: '' });
    const didMountRef = useRef(true)
    const history = useHistory()
    useEffect(() => {
        if (didMountRef.current) {
            const queryString = window.location.search;
            console.log("gdfkg",queryString)
            const urlParams = new URLSearchParams(queryString);
            const id = urlParams.get('id')
              console.log("hello==>",id)
        const dataString ={
            "id": id
        }
        apiServices.checkresetpasswordurlexpirePostRequest(dataString).then(result =>{
            if(result.data.status=="error"){
                alert(result.data.message)
                history.push("/login")
            }

        })
        }
        didMountRef.current = false;
    });

    const handleInput = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        setRegisterData({ ...registerData, [key]: value })
        if (key == 'password') {
            checkspecialchar(value);
            checkcapsmall(value);
            checkminchar(value);
        }
    }
    function checkminchar(e) {
        var a = document.getElementById('minchar');
        if (e.length > 8) {
            a.setAttribute("class", "text mg-b-5 tx-11 text-success");
            return true;
        }
        else {
            a.setAttribute("class", "text mg-b-5 tx-11 text-danger");
            return false;
        }
    }
    function checkcapsmall(e) {
        var cap = document.getElementById('capsmall');
        var pattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z]).+$");
        if (e.match(pattern)) {
            cap.setAttribute("class", "text mg-b-5 tx-11 text-success");
            return true;
        }
        else {
            cap.setAttribute("class", "text mg-b-5 tx-11 text-danger");
            return false;
        }
    }
    function checkspecialchar(e) {
        var special = document.getElementById('specialchar');
        var pattern2 = new RegExp("^(?=.*[-+_!@#$%^&*.,?]).+$");
        if (e.match(pattern2)) {
            special.setAttribute("class", "text mg-b-5 tx-11 text-success");
            return true;
        }
        else {
            special.setAttribute("class", "text mg-b-5 tx-11 text-danger");
            return false;
        }
    }
    const submitchangepassworf = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);
        if (registerData.password == '' || registerData.cnfpassword == '') {
            setErrorMessage("Pleast Enter The Credentials");
            setSpinnerLoading(false);
            return false;
        } else if (registerData.password != registerData.cnfpassword) {
            setErrorMessage("Password and Confirm Password is incorrect");
            setSpinnerLoading(false);
            return false;
        }
        else {
            if (checkspecialchar(registerData.password) && checkcapsmall(registerData.password) && checkminchar(registerData.password)) {
                setErrorMessage('');
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const id = urlParams.get('id')
                const dataString = {
                    "confirm_password": registerData.cnfpassword,
                    "password": registerData.password,
                    "id": id
                }
                apiServices.changpasswordPostRequest(dataString).then(result => {
                    if(result.data.status == "success"){
                        alert(result.data.message)
                        history.push("/login")
                        setSpinnerLoading(false)
                    }
                    else{
                        alert(result.data.message)
                        setSpinnerLoading(false)
                    }
                   })
                    .catch(error => {
                    })
            }
            else {
                setErrorMessage('Please Fullfill All Password Conditions');
                setSpinnerLoading(false);
            }
        }
    };
    return (
        <>
            <LSHeader />
            <section>
                <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                    <div className='overlay-box'>
                        <Watch
                            color="#ffffff"
                            visible={spinnerLoading}
                        />
                    </div>
                </div>
                <div className="container">
                    <div className="login-media align-items-stretch justify-content-center ht-100p">
                        <div className="login-media-img d-none align-items-center d-lg-flex">
                            <div className="mx-wd-600">
                                <img src="/img/login_bg.png" className="img-fluid" alt="" />
                            </div>
                        </div>
                        <div className="sign-wrapper">
                            <div className="wd-100p">
                                <div>
                                    <h5>Create Password</h5>
                                    <p className="tx-color-03 mg-b-4 tx-13">Please enter your password</p>
                                    <div className="form-group">
                                        <label>Password:</label>
                                        <input type="password" name="password" value={registerData.password} className="form-control" onChange={handleInput} />
                                    </div>
                                    <div className="form-group">
                                        <label>Confirm Password:</label>
                                        <input type="password" name="cnfpassword" value={registerData.cnfpassword} className="form-control" onChange={handleInput} />
                                    </div>
                                    {
                                        errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                    }
                                    <button className="btn btn-success button01 mg-b-10" onClick={submitchangepassworf}>Submit</button>
                                    <p id="minchar" className="text mg-b-5 tx-11">Minimum 8 characters</p>
                                    <p id="capsmall" className="text mg-b-5 tx-11">Have atleast 1 capital and 1 small alphabet</p>
                                    <p id="specialchar" className="text mg-b-5 tx-11">Have one of the following special characters @,#,$,-,_,%,&,!,?</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default ResetPasswordLink